'use strict';

var skeleton = require('./unlimitailSkeleton');

/**
 * Unlimitail – Category Menu integration
 *
 * When a top-level navigation item is hovered or opened, this module:
 *   1. Checks whether Unlimitail is enabled (config element must be present).
 *   2. Checks whether the category is listed in the `unlimitailMenuCategoryIds`
 *      site preference (surfaced via the `data-category-ids` attribute).
 *   3. Makes ONE GET request to `Unlimitail-Category` which internally fires
 *      a single bannerx API call covering Pictos_Marque, Nom_Marques and
 *      Coup_de_coeurs (all in the same Display-Menu placement group).
 *   4. Appends the returned HTML fragments to the open submenu body so the
 *      existing Unlimitail tracking observer picks them up automatically.
 *
 * Ads are pre-fetched on `mouseenter` of the menu item so they are ready
 * when the submenu actually opens, with `click` as a fallback guarantee.
 *
 * Required ISML side:
 *   – `.js-unlimitail-menu-config[data-enabled][data-category-ids][data-category-url]`
 *     rendered once in the menu template when the feature is active.
 *   – `data-category-id` attribute on each `.js-menu-item` li element.
 */

var unlimitailMenu = {
    config: {
        configSelector  : '.js-unlimitail-menu-config',
        menuItemSelector: '.js-menu-item',
        menuBtnSelector : '.js-menu-first-level-btn',
        menuBodySelector: '.cc-header__menu__body',
        loadedAttr      : 'data-unlimitail-menu-loaded',
        loadingAttr     : 'data-unlimitail-menu-loading'
    },

    allowedIds     : [],
    categoryEndpoint: '',

    init: function () {
        var $config = $(this.config.configSelector);

        if (!$config.length || $config.attr('data-enabled') !== 'true') {
            return;
        }

        var ids = ($config.attr('data-category-ids') || '')
            .split(',')
            .map(function (id) { return id.trim(); })
            .filter(Boolean);

        var endpoint = $config.attr('data-category-url') || '';

        if (!ids.length || !endpoint) {
            return;
        }

        this.allowedIds      = ids;
        this.categoryEndpoint = endpoint;

        this.bindMenuEvents();
    },

    bindMenuEvents: function () {
        var self = this;

        // Shared handler used by both hover and click
        function tryLoad($menuItem) {
            var categoryId = $menuItem.attr('data-category-id');

            // Skip if category is not in the allowed list
            if (!categoryId || self.allowedIds.indexOf(categoryId) === -1) {
                return;
            }

            var $menuBody = $menuItem.find(self.config.menuBodySelector);

            if (!$menuBody.length) {
                return;
            }

            // Skip if already loaded or currently loading
            if ($menuBody.attr(self.config.loadedAttr) === 'true' ||
                $menuBody.attr(self.config.loadingAttr) === 'true') {
                return;
            }

            self.loadMenuAds($menuBody, categoryId);
        }

        // Pre-fetch on hover so ads are ready when the submenu opens
        $(document).on('mouseenter.unlimitailMenu', self.config.menuItemSelector, function () {
            tryLoad($(this));
        });

        // Fallback: also trigger on click in case hover was missed
        $(document).on('click.unlimitailMenu', self.config.menuBtnSelector, function () {
            tryLoad($(this).closest(self.config.menuItemSelector));
        });
    },

    loadMenuAds: function ($menuBody, categoryId) {
        var self = this;

        $menuBody.attr(self.config.loadingAttr, 'true');

        $.ajax({
            url : self.categoryEndpoint,
            type: 'GET',
            data: { categoryId: categoryId },

            success: function (html) {
                var $placeholder = $menuBody.find('.js-unlimitail-menu-seo');
                if ($placeholder.length && html && html.trim()) {
                    skeleton.reserve($menuBody, $menuBody);
                    $placeholder.replaceWith(html);
                    skeleton.settle($menuBody);
                } else if (html && html.trim()) {
                    $menuBody.append(html);
                } else {
                    $placeholder.remove();
                }
                $menuBody.attr(self.config.loadedAttr, 'true');
                $menuBody.removeAttr(self.config.loadingAttr);
            },

            error: function () {
                $menuBody.find('.js-unlimitail-menu-seo').remove();
                $menuBody.removeAttr(self.config.loadingAttr);
            }
        });
    }
};

module.exports = {
    init: function () {
        unlimitailMenu.init();
    }
};
